import { render, staticRenderFns } from "./CardApiConsultDead.vue?vue&type=template&id=1bfafa56&"
import script from "./CardApiConsultDead.vue?vue&type=script&lang=js&"
export * from "./CardApiConsultDead.vue?vue&type=script&lang=js&"
import style0 from "./CardApiConsultDead.vue?vue&type=style&index=0&id=1bfafa56&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bfafa56')) {
      api.createRecord('1bfafa56', component.options)
    } else {
      api.reload('1bfafa56', component.options)
    }
    module.hot.accept("./CardApiConsultDead.vue?vue&type=template&id=1bfafa56&", function () {
      api.rerender('1bfafa56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardApiConsultDead.vue"
export default component.exports